import moment from "moment";
import { getDateFormatFromTenantOrBrowser } from "./date-format-helper";

export const parseToDate = (value: any) => {
  let newValue = value;
  if (value) {
    try {
      newValue = moment(value).format(getDateFormatFromTenantOrBrowser());
    } catch (error) {
      console.error("Error getting date: ", value);
    }
  }
  return newValue;
};

export const getValueDate = (value: any, utc: boolean = false) => {
  if (value === 0) {
    value = null;
  } else if (value) {
    try {
      const dateValue = utc
        ? moment.utc(value, getDateFormatFromTenantOrBrowser()).format("x")
        : moment(value, getDateFormatFromTenantOrBrowser()).format("x");
      value = dateValue !== "Invalid date" ? dateValue : null;
    } catch (error) {
      value = null;
    }
  }
  return value;
};
